import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import React from 'react';

interface MustEnableFieldProps<T> {
  value: T|undefined,
  onChange: (value: T|undefined) => void,
  defaultValue: T,
  label: string,
  input: JSX.Element,
  inputContainerStyle?: React.CSSProperties,
}

export function MustEnableField<T>({
  value, onChange, label, input, inputContainerStyle, defaultValue,
}: MustEnableFieldProps<T>) {
  return (
    <>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          label={label}
          control={(
            <Checkbox
              checked={value !== undefined}
              color="primary"
              onChange={(e, v) => onChange(v ? defaultValue : undefined)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8} style={inputContainerStyle}>
        {input}
      </Grid>
    </>
  );
}
